import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// La sessione vive solo nel cookie HttpOnly: rimuove eventuali token salvati da versioni precedenti.
try { localStorage.removeItem("token"); sessionStorage.removeItem("token"); } catch {}

// L'header personalizzato fa parte della protezione CSRF verificata dal server.
export const http = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Requested-With": "XMLHttpRequest" } });

// Durante un backup le operazioni restano sospese per pochi secondi: nuovo tentativo automatico.
http.interceptors.response.use(undefined, async (err) => {
  const cfg = err.config;
  if (err.response?.status === 503 && err.response?.data?.code === "write_freeze" && cfg && (cfg._freezeRetry || 0) < 6) {
    cfg._freezeRetry = (cfg._freezeRetry || 0) + 1;
    await new Promise((r) => setTimeout(r, 1500));
    return http(cfg);
  }
  return Promise.reject(err);
});

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  const s = e?.response?.status;
  if (s >= 500) return "Errore del server: operazione non completata. Riprova; se si ripete, segnala l'orario all'assistenza.";
  if (!e?.response) return "Server non raggiungibile: controlla la connessione e riprova.";
  return e?.message || "Errore imprevisto";
}
